export enum LocationType {
  HOME = 'home',
  VO_DETAILS = 'vo_details',
  ACTIVITY_DETAILS = 'activity_details',
  USER_DETAILS = 'user_details',
}

export enum ActionType {
  REDIRECT = 'REDIRECT',
  CAPTURE_DETAILS = 'CAPTURE_DETAILS',
  SHOW_FORM = 'SHOW_FORM',
  SHOW_TEXT = 'SHOW_TEXT',
  NAVIGATE_VIEW = 'NAVIGATE_VIEW',
}

export enum RenderType {
  HTML = 'HTML',
  JSON = 'JSON',
  PLAIN = 'PLAIN',
}

export enum RedirectType {
  INTERNAL_WEBLINK = 'INTERNAL_WEBLINK',
  EXTERNAL_WEBLINK = 'EXTERNAL_WEBLINK',
  INTERNAL_DEEPLINK = 'INTERNAL_DEEPLINK',
  EXTERNAL_DEEPLINK = 'EXTERNAL_DEEPLINK',
}

export enum MethodType {
  GET = 'GET',
  POST = 'POST',
}

export enum TileType {
  IMAGE_VIEW = 'IMAGE_VIEW',
  TEXT_VIEW = 'TEXT_VIEW',
  VERTICAL_CARD = 'VERTICAL_CARD',
  HORIZONTAL_CARD = 'HORIZONTAL_CARD',
}

export enum ShowDatailsType {
  HTML = RenderType.HTML,
  JSON = RenderType.JSON,
  PLAIN = RenderType.PLAIN,
  FORM = 'FORM',
}
